<template>
  <div>
    <input style="display:none" accept="image/*" type="file" @change="readFile" ref="fileUploadInput" />
    <ImageDisplay v-if="vm.altAcademyImage" :src="vm.altAcademyImage" style="width:100%" />
    <v-card v-if="showCroppie" elevation="0">
      <div ref="imageContainer">
        <vue-croppie v-if="showCroppie" ref="croppie" :enable-exif="true" :enableOrientation="true" @result="result"
          :viewport="croppieViewport" :boundary="croppieViewportBoundary" :enable-resize="resize" :show-zoomer="false">
        </vue-croppie>
        <v-progress-linear v-if="uploading" indeterminate color="secondary"></v-progress-linear>
      </div>
      <v-card-actions>
        <v-btn elevation="0" small @click="rotate(90)" :disabled="disableConfirm">
          <v-icon>mdi-format-rotate-90</v-icon>
          <span v-if="!isSmallerDisplay()">{{ $t("message.rotate") }}</span>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn elevation="0" small @click="processImage()" color="success" :disabled="disableConfirm">
          <v-icon v-if="uploading" class="rotate">mdi-sync</v-icon>
          <v-icon v-else>mdi-check-circle-outline</v-icon>
          <span v-if="!isSmallerDisplay()">{{ $t("message.confirm") }}</span>
        </v-btn>
        <v-btn :disabled="!showCroppie" elevation="0" small @click="closeDialog()">
          <v-icon>mdi-close-box-outline</v-icon>
          <span v-if="!isSmallerDisplay()">{{ $t("message.cancel") }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>

    <div v-if="!vm.altAcademyImage && !showCroppie" class="flex flex-col" style="gap:1.5rem;">
      <div class="plusGreyDarken1--text">{{$t("message.academy_settings_admin_plus.cover_image_upload_explanation")}}</div>
      <div class="flex flex-col" style="gap:1rem;">
        <div class="plusGreyLighten5 flex justify-center align-center" style="height:6.5rem;gap:0.625rem;border:1px dashed #BDBDBD !important;"
          @dragover.prevent
          @dragenter.prevent
          @drop.prevent="handleDrop"
          >
          <div class="plusGreyDarken1--text">{{$t("message.academy_settings_admin_plus.drag_and_drop_or")}}</div>
          <PlusButton intent="link" @click="openFileUploader()">{{$t("message.academy_settings_admin_plus.upload_image")}}</PlusButton>
        </div>
        <div class="plusGreyDarken1--text" style="font-size:0.875rem">{{$t("message.academy_settings_admin_plus.recommended_size")}}: 1200 × 400 px</div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/services/Api2";
import PlusButton from "@/components/plus/PlusButton";

export default {
  components: {
    PlusButton
  },
  data() {
    return {
      image: null,
      cropped: null,
      cropImageDialog: false,
      disableConfirm: true,
      uploadingMessage: null,
      resize: false,
      callWhenDone: null,
      buttonColor: 'primary',
      uploading: false,
      showCroppie: false,
      toBigMessage: null,
      croppieViewport: { width: 200, height: 200, type: 'square' },
      croppieViewportBoundary: { width: 250, height: 250 },
      onUploadProgress: function () {
      }
    };
  },
  props: ["successFunction", "vm", "enableResize"],
  watch: {},
  created() {
    this.callWhenDone = this.successFunction;
    if (this.enableResize)
      this.resize = this.enableResize;
  },
  methods: {
    getCroppieViewport() {
      if (!this.$refs.imageContainer) {
        this.croppieViewportBoundary = { width: 600, height: 150 };
        this.croppieViewport = { width: 600 - 30, height: 150 - 30 };
        return;
      }
      const containerWidth = this.$refs.imageContainer.clientWidth;
      if (this.$vuetify.breakpoint.name == 'xs' ||
        this.$vuetify.breakpoint.name == 'sm') {
        this.croppieViewportBoundary = { width: containerWidth, height: 150 };
        this.croppieViewport = { width: containerWidth - 30, height: 150 - 30 };
      } else {
        this.croppieViewportBoundary = { width: containerWidth, height: 350 };
        this.croppieViewport = { width: containerWidth - 30, height: 350 - 30 };
      }
    },
    handleDrop(e) {
      const droppedFiles = e.dataTransfer.files;
      if (!droppedFiles.length) return;
      this.getCroppieViewport();
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(droppedFiles[0]);
      this.$refs.fileUploadInput.files = dataTransfer.files;
      this.readFile();
    },
    closeDialog() {
      this.cropImageDialog = false;
      this.clearCroppie();
    },
    clearCroppie() {
      this.image = null;
      this.cropped = null;
      this.disableConfirm = true;
      this.uploading = false;
      this.showCroppie = false;
      this.$refs.fileUploadInput.value = null;
      this.$refs.croppie.destroy();
    },
    openFileUploader() {
      this.getCroppieViewport();
      this.$refs.fileUploadInput.click();
    },
    readFile() {
      var vm = this;
      this.toBigMessage = null;
      this.showCroppie = true;
      if (this.$refs.fileUploadInput.files && this.$refs.fileUploadInput.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
          vm.$refs.croppie.bind({
            url: e.target.result
          });
        };
        reader.readAsDataURL(this.$refs.fileUploadInput.files[0]);
      }
      this.disableConfirm = false;
    },
    processImage() {
      this.uploading = true;
      this.disableConfirm = true;
      let options = {
        format: "png",
        size: "original",
        circle: false,
        quality: 1
      };
      const vm = this;
      this.$refs.croppie.result(options, output => {
        vm.cropped = output;
        setTimeout(function () {
          vm.uploadImage(output);
        }, 4000);
      });
    },
    displayCropImageDialog() {
      this.cropImageDialog = !this.cropImageDialog;
    },
    bind() {
      if (!this.image)
        this.image = '';
      if (this.$refs.croppie) {
        this.$refs.croppie.bind({
          url: this.image
        });
      }
    },
    cropViaEvent() {
      this.$refs.croppie.result();
    },
    result(output) {
      this.cropped = output;
    },
    uploadImage(ImageURL) {
      // Split the base64 string in data and contentType
      let block = ImageURL.split(";");
      // Get the content type
      let contentType = block[0].split(":")[1]; // In this case "image/gif"
      // get the real base64 content of the file
      let realData = block[1].split(",")[1]; // In this case "iVBORw0KGg...."

      // Convert to blob
      let blob = this.b64toBlob(realData, contentType);

      // Create a FormData and append the file
      //var fd = new FormData();
      //fd.append('filename','afilename.jpg');
      //fd.append("image", blob);

      //PUSH
      try {
        //this.uploadImageFunction
        const d = new Date();
        const formData = new FormData();
        const millis = d.getTime();
        const imgExtension = contentType.toLowerCase().split('/')[1];
        formData.append("image", blob, 'uploaded-image-user-admin-' + millis + '.' + imgExtension);

        Api().post("content/image/admin", formData)
          .then(res => {
            if (res) {
              let vm = this;
              setTimeout(function () {
                vm.uploading = false;
                vm.callWhenDone(res.data.location, vm.vm);
                vm.clearCroppie();
              }, 4000);
            }
          })
          .catch(err => {
            console.log('ERROR: ', err)
            this.uploading = false;
            if (err)
              this.showAlert('error', this.$t('message.oops_not_working'));
          });
      } catch (err) {
        console.log('WTF?????', err);
        this.showAlert('error', this.$t('message.oops_not_working'));
      }
    },
    rotate(rotationAngle) {
      this.$refs.croppie.rotate(rotationAngle);
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    }
  }
};
</script>

<style scoped></style>
